import {connect} from 'react-redux';
import {List} from 'immutable';

import {
  loadJournalPartnerTag,
  updateJournalPartnerTag,
  createJournalPartnerTag,
  deleteJournalPartnerTag,
  journalPartnerTagFormDestroy
} from '../../../../../state/modules/journalPartnerTags/actions';
import {sendMessage} from '../../../../../state/actions';
import JournalPartnerTagForm from '../components/JournalPartnerTagForm';

const inputs = List([
  'label',
  'status',
  'partnership_id'
]);

const mapStateToProps = (state, ownProps) => {

  const data = {}, errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(['journalPartnerTags', ownProps.id, val], '');
    errors[val] = state.journalPartnerTags.getIn(['form', 'errors', val]);
  }

  // change select number values to strings to work with ant design select inputs
  Object.keys(data).forEach(x => {
    if (['status'].includes(x)) {
      data[x] = data[x].toString();
    }
  });

  return {
    isLoading: state.journalPartnerTags.get('isLoading'),
    isSubmitting: state.journalPartnerTags.getIn(['form', 'isSubmitting']),
    success: state.journalPartnerTags.getIn(['form', 'success']),
    created_id: state.journalPartnerTags.getIn(['form', 'created_id']),
    data: data,
    errors: errors,
    createdAt: state.entities.getIn(['journalPartnerTags', ownProps.id, 'created_at'], null),
    updatedAt: state.entities.getIn(['journalPartnerTags', ownProps.id, 'updated_at'], null),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (id, cb) => {
      dispatch(loadJournalPartnerTag(id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updateJournalPartnerTag(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createJournalPartnerTag(data, cb));
    },
    delete: (id, cb) => {
      dispatch(deleteJournalPartnerTag(id, cb))
    },
    destroyForm: (formState) => {
      dispatch(journalPartnerTagFormDestroy(formState));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const JournalPartnerTagFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(JournalPartnerTagForm);

export default JournalPartnerTagFormContainer;